import {defaultSelectedBrand} from "../brands/state";

export const defaultSelectedDate = () => {
    let today = new Date();

    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Se agrega 1 al mes ya que en JavaScript los meses van de 0 a 11.
    let day = String(today.getDate()).padStart(2, '0');

    return  `${year}-${month}-${day}`;
};

export const defaultCashRegisterUpdate = () => {
    return {
        branchoffice_warehouse_id: null,
        branchoffice_id : null,
        box_id : null,
        date_update : null,
        update_type_id : null,
        contact_id : null,
        number_document :'',
        value : '',
        detail : '',
        concept :'',
        user_id : null,
        date_last_update :'',
        id_sug :'',
    }
}

export default {
  branchoffices: [],
  type_updates: [],
  contacts: [],
  users: [],
  listCashUpdates: {
    data: [],
    total: 0
  },
  boxes: [],
  selectedCashRegisterUpdate: defaultCashRegisterUpdate(),
  action: '',
  isDisabled: false,
  fileNamePdfCashRegisterEmail: '',
  fileNamePdfCashRegister: '',
  showPdfCashRegister: false,
  loadingPdf : false ,
  params: {
    page: 1,
    perPage: 50,
    date: defaultSelectedDate(),
    branchoffice_warehouse_id: null,
    branchoffice_id: null,
    contact_id: null,
    box_id: null,
    filter: ''
  },
  isLoadingReport: false,
  listCashUpdatesExcel: ''
}



// WEBPACK FOOTER //
// ./src/modules/cash-registers-updates/state.js